enum ValidityRangeReason {
  TransportChange = 1,
  FoodChange,
  TeachingAidChange,
  PersonalTransportChange,
  TerminationOfCoFinancing
}

export default ValidityRangeReason;
